// Lo que dice Cumbre en el cuestionario corto de la prueba gratis
// (ADR-2026-10-31-el-cuestionario-corto-con-el-diseno-del-de-marca). Corto a propósito: el
// cuestionario volvió a ser corto porque el largo bajaba la conversión, y cada letra se espera.

import type { Reaccion, Tramo } from '../onboardingMarca/dialogo';

export const DIALOGO_DEL_NOMBRE: Tramo[] = [
  { texto: '¡Hola! Soy el asistente de Atlas.', estilo: 'saludo' },
  { texto: '¿Cómo se llama tu marca?', estilo: 'pregunta' },
  { texto: 'En un minuto vas a ver fotos profesionales de tus productos.', estilo: 'detalle' },
];

export function dialogoDelRubro(nombre: string | null): Tramo[] {
  return [
    { texto: nombre ? `¡Hola, ${nombre}!` : '¡Buenísimo!', estilo: 'saludo' },
    { texto: `¿A qué se dedica ${nombre ?? 'tu marca'}?`, estilo: 'pregunta' },
    { texto: 'Así te muestro ejemplos de tu rubro.', estilo: 'detalle' },
  ];
}

export const REACCION_AL_RUBRO: Reaccion = { id: 'rubro', texto: '¡Perfecto! Estoy preparando tu cuenta…' };

/** `titulo` es el de siempre del paso, que cambia si la cuenta ya paga (`tituloDelPasoDelProducto`). */
export function dialogoDelProducto(titulo: string): Tramo[] {
  return [
    { texto: '¡Ya casi!', estilo: 'saludo' },
    { texto: titulo, estilo: 'pregunta' },
    { texto: 'Si no tenés una foto a mano, elegí uno de los nuestros.', estilo: 'detalle' },
  ];
}

export const DIALOGO_DE_LA_GENERACION: Tramo[] = [
  { texto: '¡Allá vamos!', estilo: 'saludo' },
  { texto: 'Estoy creando tus primeras fotos.', estilo: 'pregunta' },
];

/** `propias`: salieron de la foto que subió (no de un producto de ejemplo). */
export function dialogoDeLosResultados(propias: boolean): Tramo[] {
  return [
    { texto: '¡Listo!', estilo: 'saludo' },
    { texto: propias ? 'Estas son tus primeras fotos.' : 'Así quedan las fotos de este producto.', estilo: 'pregunta' },
    { texto: 'Tocá una para verla grande y descargarla.', estilo: 'detalle' },
  ];
}
